var _path, _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Group 4",
    viewBox: "0 0 108.619 47.803"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M32.934 7.841h9.277v2.325h-6.818v3.845h5.5v2.324h-5.5v4.83h7.042v2.325h-9.5z",
    "data-name": "Path 1"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M50.777 13.832l-1.476 1.3a2.389 2.389 0 00-1.967-1.029 1.056 1.056 0 00-1.118 1.118.966.966 0 00.291.693 4.224 4.224 0 001.722.916 6.622 6.622 0 011.743.827 2.719 2.719 0 011.408 2.437 3.411 3.411 0 01-1.073 2.548 3.889 3.889 0 01-2.839 1.029 4.722 4.722 0 01-4.359-3.018l1.967-1.074c.6 1.365 1.431 2.035 2.482 2.035a1.327 1.327 0 001.52-1.475.958.958 0 00-.581-.894 2.991 2.991 0 00-.581-.313c-.335-.156-1.162-.447-1.52-.6q-2.415-1.006-2.414-3.085a2.979 2.979 0 01.983-2.258 3.426 3.426 0 012.482-.939 3.984 3.984 0 013.331 1.789",
    "data-name": "Path 2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M59.586 13.832l-1.476 1.3a2.389 2.389 0 00-1.967-1.029 1.056 1.056 0 00-1.118 1.118.967.967 0 00.295.69 4.224 4.224 0 001.722.916 6.622 6.622 0 011.744.827 2.72 2.72 0 011.408 2.437 3.411 3.411 0 01-1.073 2.548 3.89 3.89 0 01-2.839 1.029 4.722 4.722 0 01-4.359-3.018l1.967-1.074c.6 1.365 1.431 2.035 2.482 2.035a1.327 1.327 0 001.52-1.475.959.959 0 00-.581-.894 3 3 0 00-.581-.313c-.335-.156-1.162-.447-1.52-.6q-2.415-1.006-2.414-3.085a2.979 2.979 0 01.983-2.258 3.426 3.426 0 012.482-.939 3.984 3.984 0 013.331 1.789",
    "data-name": "Path 3"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M63.498 16.56h5.477a2.646 2.646 0 00-2.727-2.459 2.741 2.741 0 00-2.75 2.459m7.936 1.945h-7.981a2.8 2.8 0 002.794 3.108 3.251 3.251 0 002.951-1.9l1.99.782c-1.14 2.213-2.459 3.175-4.94 3.175-3.711 0-5.254-3.13-5.254-5.812s1.542-5.813 5.254-5.813c3.6 0 5.186 2.929 5.186 5.455z",
    "data-name": "Path 4"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M72.801 12.223h2.325v1.923a4.193 4.193 0 013.644-2.1 3.1 3.1 0 013.308 3.375v8.071h-2.324v-7.335c0-1.364-.582-2.057-1.744-2.057a2.468 2.468 0 00-2.034 1.319 6.419 6.419 0 00-.85 3.51v4.561h-2.325z",
    "data-name": "Path 5"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M82.795 14.28v-2.057h1.878V9.799l2.325-2.353v4.777h2.929v2.057h-2.929v5.5c0 1.229.492 1.833 1.5 1.833a2.065 2.065 0 001.074-.313l.6 1.967a4.126 4.126 0 01-1.811.4c-2.236 0-3.689-1.364-3.689-4.025V14.28z",
    "data-name": "Path 6"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M91.426 12.222h2.325v11.267h-2.325zm.022-4.315a1.58 1.58 0 012.28 0 1.62 1.62 0 010 2.28 1.691 1.691 0 01-2.3 0 1.64 1.64 0 01.022-2.28",
    "data-name": "Path 7"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M99.182 21.611a3.1 3.1 0 002.057-.738 2.616 2.616 0 00.894-2.124v-.246h-2.034c-1.431 0-2.325.671-2.325 1.744a1.281 1.281 0 001.408 1.364m1.006-5.052h1.945v-.492c0-1.341-.917-1.967-2.191-1.967a2.081 2.081 0 00-2.1 1.5l-2.124-.447a4.128 4.128 0 014.247-3.108c3 0 4.494 1.476 4.494 4.449v7h-1.967l-.224-1.476a4.015 4.015 0 01-3.487 1.655 3.2 3.2 0 01-3.465-3.42c0-2.3 1.945-3.689 4.874-3.689",
    "data-name": "Path 8"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M106.294 7.662h2.325V23.49h-2.325z",
    "data-name": "Rectangle 4"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M32.934 27.415h2.459v13.324h6.751v2.325h-9.21z",
    "data-name": "Path 9"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M43.197 31.797h2.325v11.267h-2.325zm.022-4.315a1.58 1.58 0 012.28 0 1.62 1.62 0 010 2.281 1.691 1.691 0 01-2.3 0 1.641 1.641 0 01.022-2.281",
    "data-name": "Path 10"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M46.194 31.797h2.369l2.459 8.093 2.459-8.093h2.37l-3.734 11.267h-2.191z",
    "data-name": "Path 11"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M56.567 31.797h2.325v11.267h-2.325zm.022-4.315a1.58 1.58 0 012.28 0 1.619 1.619 0 010 2.281 1.691 1.691 0 01-2.3 0 1.641 1.641 0 01.022-2.281",
    "data-name": "Path 12"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M60.793 31.797h2.33v1.923a4.193 4.193 0 013.644-2.1 3.1 3.1 0 013.308 3.376v8.071h-2.324v-7.333c0-1.363-.582-2.056-1.744-2.056a2.47 2.47 0 00-2.034 1.319 6.42 6.42 0 00-.85 3.51v4.561h-2.33z",
    "data-name": "Path 13"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M77.986 35.396a1.778 1.778 0 10-1.788 1.833 1.713 1.713 0 001.788-1.833m-2.861 7.266a9.173 9.173 0 01-1.14-.067 1.858 1.858 0 00-.492 1.363c0 1.14 1.029 1.833 2.728 1.833 1.609 0 2.571-.626 2.571-1.7 0-.962-.626-1.431-1.855-1.431zm-1.81-10.016a4.108 4.108 0 012.884-1.029 4.356 4.356 0 011.867.4c.064.03 1.459-1.366 1.459-1.366l1.99 1.885s-1.512 1.493-1.508 1.505a3.761 3.761 0 01.238 1.358 3.558 3.558 0 01-1.14 2.772 4.22 4.22 0 01-2.906 1.006 4.826 4.826 0 01-1.811-.335 1.075 1.075 0 00-.6.984c0 .581.38.871 1.162.871h2.482c2.258 0 3.733 1.141 3.733 3.22a3.271 3.271 0 01-1.43 2.929 6.014 6.014 0 01-3.51.961c-2.951 0-4.963-1.319-4.963-3.71a2.973 2.973 0 01.961-2.28 2.418 2.418 0 01-.648-1.766 2.461 2.461 0 011.364-2.281 3.589 3.589 0 01-.76-2.369 3.543 3.543 0 011.14-2.75",
    "data-name": "Path 14"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffdc00",
    d: "M0 0v23.49h23.489v-8.224h-2.362v5.861H2.362V2.362h18.765v5.376l-4.634 4.634 1.67 1.671 4.98-4.98.346-.349V0z",
    "data-name": "Path 15"
  })))));
}

export default __webpack_public_path__ + "3c46c9ab80664f799ac069aed6e21c15.svg";
export { SvgLogo as ReactComponent };